import {StyleSheet} from 'react-native';
import {Colors} from '../../../../constants/Colors';

export const styles = StyleSheet.create({
  progress: {
    height: 40,
    borderColor: Colors.GrayPallete.lightgrayTwo,
  },
  CardContainer: {
    width: '100%',
    minHeight: 109,
    borderRadius: 5,
  },
  CardContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 109,
  },
  label: {
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 19,
    color: 'black',
  },
  ContainerDate: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 10,
  },
  preDate: {
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 14,
    color: Colors.GrayPallete.lightgrayThree,
  },
  dateText: {
    fontSize: 12,
    fontWeight: '600',
    lineHeight: 14,
    color: Colors.GrayPallete.lightgrayThree,
  },
  ContainerDrop: {
    flexDirection: 'column',
    paddingHorizontal: 20,
    paddingVertical: 50,
  },
  Check: {
    position: 'absolute',
    left: -11,
    backgroundColor: 'white',
  },
  OrderText: {
    marginLeft: 20,
    color: 'black',
    fontFamily: 'TCCC-UnityHeadline Regular',
    fontSize: 12,
    lineHeight: 14,
  },
  OrderTextGray: {
    marginLeft: 20,
    color: Colors.GrayPallete.lightgrayTwo,
    fontFamily: 'TCCC-UnityHeadline Regular',
    fontSize: 12,
    lineHeight: 14,
  },
  CheckCenter: {
    position: 'absolute',
    left: -10,
    backgroundColor: 'white',
    justifyContent: 'center',
  },
});
